import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import Property from "@/pages/Property";
import SEOLanding from "@/pages/SEOLanding";
import CustomPage from "@/pages/CustomPage";
import NotFound from "@/pages/NotFound";

// Tries property first, then custom page, then SEO landing.
export default function SlugRouter() {
  const { slug } = useParams();
  const [kind, setKind] = useState(null); // "property" | "custom" | "seo" | "404"

  useEffect(() => {
    let cancelled = false;
    setKind(null);
    (async () => {
      try {
        await api.get(`/public/properties/${slug}`);
        if (!cancelled) setKind("property");
        return;
      } catch (_) { /* not a property */ }
      try {
        await api.get(`/public/pages/${slug}`);
        if (!cancelled) setKind("custom");
        return;
      } catch (_) { /* not a custom page */ }
      try {
        await api.get(`/public/seo-pages/${slug}`);
        if (!cancelled) setKind("seo");
        return;
      } catch (_) { /* not seo */ }
      if (!cancelled) setKind("404");
    })();
    return () => { cancelled = true; };
  }, [slug]);

  if (!kind) return <div className="pt-32 pb-32 container-x"><div className="animate-pulse h-96 bg-bone" /></div>;
  if (kind === "property") return <Property />;
  if (kind === "custom") return <CustomPage />;
  if (kind === "seo") return <SEOLanding />;
  return <NotFound />;
}
